import React, { useEffect, useState } from "react";
import { errorMsg, successMsg } from "../../Toastify";
import { useSelector } from "react-redux";
import { CreateProductMaster, CreateProductQuantity, GetProductList, UpdateProductMaster } from "../../../Repository/Api";
import CustomModal from "../../CustomModal";
import { NonEmptyValidation, NumberValidation, NumberValidationAllowZero, StringValidation } from "../../../Store/validate";
import { Link } from "react-router-dom";

const ProductManagement = () => {
  const { first_name, desingation, access_token } = useSelector((state) => state?.auth?.auth);
  const token = access_token;

  const [product, setProduct] = useState([]);
  const [masterModel, setMasterModel] = useState(false);
  const [quantityModel, setQuantityModel] = useState(false);
  const [createProduct, setCreateProduct] = useState({});
  const [createQuantity, setCreateQuantity] = useState({});
  const [validation, setValidation] = useState({});

  useEffect(() => {
    getProductlist();
  }, []);

  const getProductlist = async () => {
    const response = await GetProductList(token);
    if (response && response.statusCode === 200) {
      setProduct(response?.data?.product);
    } else {
      errorMsg(response.message);
    }
  };
  const setData = (e, key) => {
    setCreateProduct({ ...createProduct, [key]: e });
    setCreateQuantity({ ...createQuantity, [key]: e });
    if (validation[key]) setValidation({ ...validation, [key]: false });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    let validate = {};
    validate.name = NonEmptyValidation(createProduct?.name);
    validate.specification = NonEmptyValidation(createProduct?.specification);
    validate.minimum_quantity_available = NumberValidation(createProduct?.minimum_quantity_available);
    validate.max_quantity_ordered = NumberValidation(createProduct?.max_quantity_ordered);
    validate.quantity = NumberValidationAllowZero(createProduct?.quantity);

    setValidation(validate);
    if (Object.values(validate).every((v) => v.status === true)) {
      const Payload = {
        name: createProduct.name,
        specification: createProduct.specification,
        minimum_quantity_available: createProduct.minimum_quantity_available,
        max_quantity_ordered: createProduct.max_quantity_ordered,
        quantity: Number(createProduct.quantity),
      };
      const response = await CreateProductMaster(Payload, token);
      if (response && response.statusCode === 200) {
        successMsg(response.message);
        setCreateProduct({});
        setMasterModel(false);
        e.target.reset();
        getProductlist();
      } else {
        errorMsg(response.message);
      }
    }
  };
  const handleUpdate = async (e) => {
    e.preventDefault();

    let validate = {};
    validate.name = NonEmptyValidation(createProduct?.name);
    validate.specification = NonEmptyValidation(createProduct?.specification);
    validate.quantity = NumberValidationAllowZero(createProduct?.quantity);
    validate.minimum_quantity_available = NumberValidation(createProduct?.minimum_quantity_available);
    validate.max_quantity_ordered = NumberValidation(createProduct?.max_quantity_ordered);

    setValidation(validate);

    if (Object.values(validate).every((v) => v.status === true)) {
      const Payload = {
        id: createProduct.id,
        name: createProduct.name,
        specification: createProduct.specification,
        minimum_quantity_available: createProduct.minimum_quantity_available,
        max_quantity_ordered: createProduct.max_quantity_ordered,
        status: createProduct.status,
        quantity: Number(createProduct.quantity),
      };
      const response = await UpdateProductMaster(Payload, token);
      if (response && response.statusCode === 200) {
        successMsg(response.message);
        setCreateProduct({});
        setMasterModel(false);
        e.target.reset();
        getProductlist();
      } else {
        errorMsg(response.message);
      }
    }
  };
  const handleSubmitQuantity = async (e) => {
    e.preventDefault();

    let validate = {};
    validate.purchased_from = NonEmptyValidation(createQuantity?.purchased_from);
    validate.quantity = NumberValidation(createQuantity?.quantity);
    validate.per_unit_price = NumberValidation(createQuantity?.per_unit_price);
    validate.purchased_date = NonEmptyValidation(createQuantity?.purchased_date);

    setValidation(validate);

    if (Object.values(validate).every((v) => v.status === true)) {
      const Payload = {
        product_id: createQuantity?.id,
        purchased_from: createQuantity.purchased_from,
        quantity: createQuantity.quantity,
        per_unit_price: createQuantity.per_unit_price,
        purchased_date: createQuantity.purchased_date,
      };
      const response = await CreateProductQuantity(Payload, token);
      if (response && response.statusCode === 200) {
        successMsg(response.message);
        setCreateQuantity({});
        setQuantityModel(false);
        e.target.reset();
        getProductlist();
      } else {
        errorMsg(response.message);
      }
    }
  };

  return (
    <>
      <div>
        <div className="d-flex justify-content-end mb-3">
          <button type="button" className="btn add-btn" onClick={() => setMasterModel(true)}>
            <span className="material-symbols-outlined align-middle iconsize">add_circle</span>
            <span className="align-middle"> Add</span>
          </button>
        </div>
        <div className="graphbox">
          <div className="scroll-table">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th scope="col">S.No</th>
                  <th scope="col">Product Name</th>
                  <th scope="col">Quantity</th>
                  <th scope="col">Min Quantity Available</th>
                  <th scope="col">Max Quantity Ordered</th>
                  <th scope="col">Status</th>
                  <th scope="col">Details</th>
                  <th scope="col">Add Quantity</th>
                </tr>
              </thead>
              <tbody>
                {product.length > 0 ? (
                  product &&
                  product.map((productitem, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td
                        className="namelink textformat"
                        onClick={() => {
                          setMasterModel(true);
                          setCreateProduct(productitem);
                        }}
                      >
                        {productitem?.name}
                      </td>
                      <td>{productitem?.quantity}</td>
                      <td>{productitem?.minimum_quantity_available}</td>
                      <td>{productitem?.max_quantity_ordered}</td>
                      <td className={productitem?.status === "active" ? "till-active" : "not-active"}>{productitem?.status}</td>
                      <td className="viewoption">
                        <Link to={`/app/Stores/StoreProductspecificview/${productitem?.id}`}>View</Link>
                      </td>
                      <td
                        className="resetbuttonoption"
                        onClick={() => {
                          setQuantityModel(true);
                          setCreateQuantity(productitem);
                        }}
                      >
                        <span className="material-symbols-outlined">production_quantity_limits</span>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>
                      <div> No Data Found </div>
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Product Model */}
      <CustomModal
        open={masterModel}
        onClickOutside={() => {
          setMasterModel(false);
          setCreateProduct({});
        }}
      >
        <form
          onSubmit={(e) => {
            if (createProduct.id) {
              handleUpdate(e);
            } else {
              handleSubmit(e);
            }
          }}
        >
          <div className="modal-content m-auto">
            <div className="modalHeader text-center py-2">
              <h5 className="font-bold mt-2">
                {createProduct.id ? "Update" : "Add New"}
                &nbsp;Product Master
              </h5>
            </div>
            <div className="modal-body ">
              <div className="container">
                <div className="row">
                  <div className="col-lg-6">
                    <div>
                      <label className="labeltext">Name of the Product :</label>
                      <input
                        type="text"
                        className="fieldinput"
                        placeholder="Enter Name of the Product"
                        defaultValue={createProduct?.name}
                        onChange={(e) => {
                          setData(e.target.value, "name");
                        }}
                      />
                    </div>
                    <small className="validationerror">{validation?.name?.message ? `Nature of Leave ${validation?.name?.message}` : ""}</small>
                  </div>
                  <div className="col-lg-6">
                    <div>
                      <label className="labeltext">Quantity :</label>
                      <input
                        type="text"
                        className="fieldinput"
                        placeholder="Enter Quantity Available"
                        defaultValue={createProduct?.quantity}
                        onChange={(e) => {
                          setData(e.target.value, "quantity");
                        }}
                      />
                    </div>
                    <small className="validationerror">{validation?.quantity?.message ? `Quantity Available ${validation?.quantity?.message}` : ""}</small>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-6">
                    <div>
                      <label className="labeltext">Minimum Quantity Available :</label>
                      <input
                        type="text"
                        className="fieldinput"
                        placeholder="Enter Quantity Available"
                        defaultValue={createProduct?.minimum_quantity_available}
                        onChange={(e) => {
                          setData(e.target.value, "minimum_quantity_available");
                        }}
                      />
                    </div>
                    <small className="validationerror">{validation?.minimum_quantity_available?.message ? `Quantity Available ${validation?.minimum_quantity_available?.message}` : ""}</small>
                  </div>
                  <div className="col-lg-6">
                    <div>
                      <label className="labeltext">Maximum Quantity Ordered :</label>
                      <input
                        type="text"
                        className="fieldinput"
                        placeholder="Enter Name Quantity Ordered"
                        defaultValue={createProduct?.max_quantity_ordered}
                        onChange={(e) => {
                          setData(e.target.value, "max_quantity_ordered");
                        }}
                      />
                    </div>
                    <small className="validationerror">{validation?.max_quantity_ordered?.message ? `Quantity Ordered ${validation?.max_quantity_ordered?.message}` : ""}</small>
                  </div>
                </div>

                <div className="row">
                  <div className="col-lg-6">
                    <div>
                      <label className="labeltext">Product Specification :</label>
                      <textarea
                        type="text"
                        className="fieldinput"
                        placeholder="Enter Product Specification"
                        defaultValue={createProduct?.specification}
                        onChange={(e) => {
                          setData(e.target.value, "specification");
                        }}
                      />
                    </div>
                    <small className="validationerror">{validation?.specification?.message ? `Specification ${validation?.specification?.message}` : ""}</small>
                  </div>
                  {createProduct.id ? (
                    <div className="col-lg-6">
                      <div>
                        <label className="labeltext">Status :</label>
                        <select className="fieldinput" defaultValue={createProduct?.status} onChange={(e) => setData(e.target.value, "status")}>
                          <option value="">Select Status</option>
                          <option value="active">Active</option>
                          <option value="inactive">InActive</option>
                        </select>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
            <div className="modal-footer border-0">
              <div>
                <button
                  type="button"
                  className="btn mx-2 submit-btn"
                  onClick={() => {
                    setMasterModel(false);
                    setValidation({});
                    setCreateProduct({});
                  }}
                >
                  Back
                </button>
              </div>
              <div>
                <button className="btn mx-2 submit-btn">{createProduct.id ? "Update" : "Create"}</button>
              </div>
            </div>
          </div>
        </form>
      </CustomModal>

      {/* Quantity Model */}
      <CustomModal
        open={quantityModel}
        onClickOutside={() => {
          setQuantityModel(false);
          setCreateQuantity({});
        }}
      >
        <form
          onSubmit={(e) => {
            handleSubmitQuantity(e);
          }}
        >
          <div className="modal-content m-auto">
            <div className="modalHeader text-center py-2">
              <h5 className="font-bold mt-2">Add New Quantity</h5>
            </div>
            <div className="modal-body ">
              <div className="container">
                <div className="row">
                  <div className="col-lg-6">
                    <div>
                      <label className="labeltext">Name of the Vender :</label>
                      <input
                        type="text"
                        className="fieldinput"
                        placeholder="Enter Name of the vender"
                        defaultValue={createQuantity?.purchased_from}
                        onChange={(e) => {
                          setData(e.target.value, "purchased_from");
                        }}
                      />
                    </div>
                    <small className="validationerror">{validation?.purchased_from?.message ? `Vender Name ${validation?.purchased_from?.message}` : ""}</small>
                  </div>
                  <div className="col-lg-6">
                    <div>
                      <label className="labeltext">Quantity :</label>
                      <input
                        type="text"
                        className="fieldinput"
                        placeholder="Enter Quantity"
                        onChange={(e) => {
                          setData(e.target.value, "quantity");
                        }}
                      />
                    </div>
                    <small className="validationerror">{validation?.quantity?.message ? `Quantity ${validation?.quantity?.message}` : ""}</small>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-6">
                    <div>
                      <label className="labeltext">Unit Price :</label>
                      <input
                        type="text"
                        className="fieldinput"
                        placeholder="Enter Unit Price"
                        defaultValue={createQuantity?.per_unit_price}
                        onChange={(e) => {
                          setData(e.target.value, "per_unit_price");
                        }}
                      />
                    </div>
                    <small className="validationerror">{validation?.per_unit_price?.message ? `Unit Price ${validation?.per_unit_price?.message}` : ""}</small>
                  </div>
                  <div className="col-lg-6">
                    <div>
                      <label className="labeltext">Purchased Date :</label>
                      <input type="date" className="fieldinput" placeholder="Enter" defaultValue={createQuantity?.purchased_date} onChange={(e) => setData(e.target.value, "purchased_date")} />
                    </div>
                    <small className="validationerror">{validation?.purchased_date?.message ? `Purchased Date ${validation?.purchased_date?.message}` : ""}</small>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer border-0">
              <div>
                <button
                  type="button"
                  className="btn mx-2 submit-btn"
                  onClick={() => {
                    setQuantityModel(false);
                    setValidation({});
                    setCreateQuantity({});
                  }}
                >
                  Back
                </button>
              </div>
              <div>
                <button className="btn mx-2 submit-btn">Update Quantity</button>
              </div>
            </div>
          </div>
        </form>
      </CustomModal>
    </>
  );
};

export default ProductManagement;
